import { apiMipe } from '@/core/api/';

const apiUrl = 'api/virtualassistant';

export const sendChat = (payload) => {
  return apiMipe.post(`${apiUrl}/chat`, payload, {
    headers: {
      skipLoading: true,
    },
  });
};

export const getCitationFile = async (citation) => {
  return apiMipe.get(`${apiUrl}/citation/file`, {
    params: {
      citation,
    },
    headers: {
      skipLoading: true,
    },
  });
};
